import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import Product from "./Product";
import AddProductButton from "./AddProductButton";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {
    Col,
    Form,
    FormFeedback,
    Row,
    Input,
    Label,
    Button,
    UncontrolledAccordion,
    AccordionItem,
    AccordionHeader, AccordionBody, Accordion
} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {getProducts} from "../../api/api";
import {toast} from "react-toastify";
import RecordsNotFound from "../../components/RecordsNotFound";
import ImportProductsButton from "./ImportProductsButton";


function ProductPage() {
    // const queryClient = useQueryClient();
    const { refreshToken, user } = useContext(AuthContext);
    const [page, setPage] = useState(1);

    const [productId, setProductId] = useState("");
    const [productName, setProductName] = useState("");
    const [productPrice, setProductPrice] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [productCreatedDate, setProductCreatedDate] = useState("");
    const [productIsDigital, setProductIsDigital] = useState("");
    const [productStock, setProductStock] = useState("");
    const [productTaxType, setProductTaxType] = useState("");
    const [productTaxPercentage] = useState("")
    const [productStatus, setProductStatus] = useState("");
    const [productUPC, setProductUPC] = useState("");
    const [productUpdatedDate, setProductUpdatedDate] = useState("");


    const [queryKey, setQueryKey] = useState(['products', page]);
    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);

    const [isAdvancedSearchDisabled, setIsAdvancedSearchDisabled] = useState(false);
    const [isProductURLDisabled, setIsProductURLDisabled] = useState(false);

    const toggleAdvancedSearch = () => setOpenAdvancedSearch((prevState) => !prevState);

    useEffect(() => {
        setQueryKey(['products', page]);
    }, [page]);

    useEffect(() => {
        if (
            productId === '' && productName === '' && productPrice === '' && productUPC === '' && productDescription === ''
            && productIsDigital === '' && productCreatedDate === ''  && productStock === '' && productTaxType === '' &&
            productTaxPercentage === '' && productStatus === ''  && productUpdatedDate === ''
        ) {
            clearSearchProduct();
        }
    }, [
        productId, productName, productPrice, productDescription, productIsDigital, productStock, productTaxType, productTaxPercentage, productStatus, productUPC,  productCreatedDate, productUpdatedDate
    ]);

    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getProducts(
            page, productId, productName, productPrice, productUPC, productDescription, productIsDigital, '', productStock, productTaxType, productTaxPercentage,'', productStatus, productCreatedDate, productUpdatedDate
        ),
        keepPreviousData: true,
        retry: false,
        refetchOnWindowFocus: false,
        onError: (err) => {
            handleUnauthorized401QueryError(err, refreshToken, refetch);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const shouldShowInitialLoader = status === 'loading' && !data;
    const shouldShowProductTable = status === 'success' || Boolean(data) || error?.response?.status === 401;

    const searchProduct = (e) => {
        e?.preventDefault();
        setPage(1);
        setQueryKey([
            'products', page, productId, productName, productPrice, productUPC, productDescription,
            productIsDigital, productStock, productCreatedDate, productTaxType, productTaxPercentage, productStatus, productUpdatedDate
        ]);
    };

    const clearSearchProduct = (e) => {
        e?.preventDefault()
        setProductId('')
        setProductName('')
        setProductDescription('')
        setProductPrice('')
        setProductCreatedDate('')
        setProductIsDigital('')
        setProductStock('')
        setProductTaxType('')
        setProductStatus('')
        setProductUPC('')
        setProductUpdatedDate('')
        setQueryKey( ['products', 1])
        // setPage(1)
    };

    return (
        <>
            <UncontrolledAccordion defaultOpen="" flush={true}>
                <AccordionItem>
                    <AccordionHeader targetId="1">
                        <span><i className="mdi mdi-filter"/></span>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                        <div className="card-box">
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form onSubmit={searchProduct}>
                                        <Row className="form-row align-items-center">
                                            <Col>
                                                <Label className="visually-hidden" for="name">Product Name</Label>
                                                <Input
                                                    id="name"
                                                    name="name"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setProductName(e.target.value)}
                                                    value={productName}
                                                    invalid={error && error.response.data.name}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.name}</FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="price">Price</Label>
                                                <Input
                                                    id="price"
                                                    name="price"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setProductPrice(e.target.value)}
                                                    value={productPrice}
                                                    invalid={error && error.response.data.price}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.price}</FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="description">Description</Label>
                                                <Input
                                                    id="description"
                                                    name="description"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setProductDescription(e.target.value)}
                                                    value={productDescription}
                                                    invalid={error && error.response.data.description}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.description}</FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="product-status">Status</Label>
                                                <Input
                                                    type="select"
                                                    id="product-status"
                                                    className="form-control mb-2"
                                                    value={productStatus}
                                                    onChange={(e) => setProductStatus(e.target.value)}
                                                >
                                                    <option value="">--</option>
                                                    <option value={"ACTIVE"}>Active</option>
                                                    <option value={"INACTIVE"}>Inactive</option>
                                                </Input>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="date-created">Date Created</Label>
                                                <Input
                                                    id="date-created"
                                                    name="date-created"
                                                    type="date"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setProductCreatedDate(e.target.value)}
                                                    value={productCreatedDate}
                                                    invalid={error && error.response.data.created}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.created}</FormFeedback>
                                            </Col>
                                        </Row>
                                        {!isAdvancedSearchDisabled && (
                                            <>
                                                <Row className="form-row align-items-center">
                                                    <Col>
                                                        <div className="form-check">
                                                            <Input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="advanced-search"
                                                                defaultChecked={openAdvancedSearch}
                                                                disabled={isAdvancedSearchDisabled}
                                                                onChange={() => toggleAdvancedSearch()}
                                                            />
                                                            <Label check className="form-check-label mb-2" for="advanced-search">
                                                                Advanced Search
                                                            </Label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Accordion open={openAdvancedSearch}>
                                                    <AccordionItem>
                                                        <AccordionBody accordionId={true}>
                                                            <Row className="form-row align-items-center">
                                                                <Col>
                                                                    <Label className="visually-hidden" for="product-type">Tax Type</Label>
                                                                    <Input
                                                                        type="select"
                                                                        id="inputState"
                                                                        className="form-control mb-2"
                                                                        value={productTaxType}
                                                                        onChange={(e) => setProductTaxType(e.target.value)}
                                                                    >
                                                                        <option value="">--</option>
                                                                        <option value={"TAX-INCLUSIVE"}>Tax Inclusive</option>
                                                                        <option value={"TAX-EXCLUSIVE"}>Tax Exclusive</option>
                                                                    </Input>
                                                                </Col>
                                                                <Col>
                                                                    <Label className="visually-hidden" for="stock">Stock</Label>
                                                                    <Input
                                                                        id="stock"
                                                                        name="stock"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) => setProductStock(e.target.value)}
                                                                        value={productStock}
                                                                        invalid={error && error.response.data.stock}
                                                                    />
                                                                    <FormFeedback invalid>{error && error.response.data.stock}</FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label className="visually-hidden" for="tax">UPC</Label>
                                                                    <Input
                                                                        id="upc"
                                                                        name="upc"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) => setProductUPC(e.target.value)}
                                                                        value={productUPC}
                                                                        invalid={error && error.response.data.upc}
                                                                    />
                                                                    <FormFeedback invalid>{error && error.response.data.upc}</FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label className="visually-hidden" for="product-type">Type</Label>
                                                                    <Input
                                                                        type="select"
                                                                        id="inputState"
                                                                        className="form-control mb-2"
                                                                        value={productIsDigital}
                                                                        onChange={(e) => setProductIsDigital(e.target.value)}
                                                                    >
                                                                        <option value="">--</option>
                                                                        <option value={true}>Digital Product</option>
                                                                        <option value={false}>Physical Product</option>
                                                                    </Input>
                                                                </Col>
                                                                <Col>
                                                                    <Label className="visually-hidden" for="date-updated">Date Updated</Label>
                                                                    <Input
                                                                        id="date-updated"
                                                                        name="date-updated"
                                                                        type="date"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) => setProductUpdatedDate(e.target.value)}
                                                                        value={productUpdatedDate}
                                                                        invalid={error && error.response.data.updated}
                                                                    />
                                                                    <FormFeedback invalid>{error && error.response.data.updated}</FormFeedback>
                                                                </Col>
                                                            </Row>
                                                        </AccordionBody>
                                                    </AccordionItem>
                                                </Accordion>
                                            </>
                                        )}
                                        <Row className="form-row align-items-center">
                                            {isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button
                                                        type="submit"
                                                        className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                        disabled={!productName && !productPrice && !productDescription &&
                                                            !productStatus && !productCreatedDate}
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        onClick={clearSearchProduct}
                                                        className="btn bx-btn-primary waves-effect waves-light"
                                                        disabled={!productName && !productPrice && !productDescription &&
                                                            !productStatus && !productCreatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                            {!isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button
                                                        type="submit"
                                                        className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                        disabled={!productName && !productPrice && !productDescription &&
                                                            !productIsDigital && !productCreatedDate && !productTaxType
                                                            && !productStock && !productUPC && !productStatus &&
                                                            !productUpdatedDate}
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        onClick={clearSearchProduct}
                                                        className="btn bx-btn-primary waves-effect waves-light"
                                                        disabled={!productName && !productPrice && !productDescription &&
                                                            !productIsDigital && !productCreatedDate && !productTaxType
                                                            && !productStock && !productUPC && !productStatus &&
                                                            !productUpdatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </UncontrolledAccordion>
            <div className="row">
                <div className="col-12">
                    <div className="card-box">
                        <AddProductButton />
                        <ImportProductsButton/>
                        {shouldShowInitialLoader && (
                            <Loader size={'default'} />
                        )}
                        {shouldShowProductTable && (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-centered mb-0">
                                        <thead className="font-13 bg-light text-muted">
                                        <tr>
                                            <th className="font-weight-medium"> Image</th>
                                            <th className="font-weight-medium">Product Name</th>
                                            <th className="font-weight-medium">Price</th>
                                            <th className="font-weight-medium">Product Short URL</th>
                                            <th className="font-weight-medium">Status</th>
                                            <th className="font-weight-medium">Stock</th>
                                            <th className="font-weight-medium">Inventory Tracking</th>
                                            <th className="font-weight-medium">Created</th>
                                            <th className="font-weight-medium text-center">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data?.count > 0 ? data?.results?.map(product => (
                                            <Product key={product.id} product={product} isProductURLDisabled={isProductURLDisabled} />
                                        )) : <RecordsNotFound />}
                                        </tbody>
                                    </table>
                                </div>
                                {status === 'success' && (
                                    <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProductPage;
